import { Component, OnInit } from '@angular/core';
import {MenuItem} from '../main-menu/main-menu.component';
import {UserModel} from '../../../user/models/UserModel';
import {AuthService} from '../../../user/services/auth/auth.service';
import {Router} from '@angular/router';
import {CurrentUserService} from '../../../user/services/current-user/current-user.service';

@Component({
  selector: 'app-cerf-menu',
  templateUrl: './cerf-menu.component.html',
  styleUrls: ['./cerf-menu.component.scss']
})
export class CerfMenuComponent implements OnInit {

  public items: MenuItem[] = [
    {
      label: 'Dashboard',
      url: '/dashboard',
      permissions: []
    },
    {
      label: 'New CERF',
      url: '/new-cerf',
      wildcard: true,
      permissions: []
    },
    {
      label: 'Reports',
      url: '/cerf-report',
      wildcard: true,
      permissions: ['view-cerf-reports']
    },
  ];

  public user: UserModel;


  constructor(public auth: AuthService,
              public router: Router,
              private currentUserService: CurrentUserService) {
  }

  ngOnInit() {
    this.currentUserService.getCurrentUser().subscribe((user) => {
      this.user = user;
    });
  }

  getMenuItems(): MenuItem[] {
    if (!this.user)
      return [];
    return this.items.filter((item: MenuItem) => this.user.can(item.permissions))
      .map(item => {
        item.active = false;
        if (item.wildcard && this.router.url.indexOf(item.url) !== -1)
          item.active = true;
        else if (item.url === this.router.url)
           item.active = true;
        return item;
      });
  }

  itemClicked(item) {
    this.router.navigate([item.url]);
  }

}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/layout/components/cerf-menu/cerf-menu.component.ts